module.exports = __webpack_public_path__ + "static/img/home_icon_register_1.56e201a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/home_icon_register_1.png
// module id = NMEL
// module chunks = 0